// src/pages/RegisterPage.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import apiClient from '../api/axios';

const RegisterPage = () => {
    const [name, setName] = useState(''); // Состояние для имени
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [consent, setConsent] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            // Включаем имя в запрос
            const response = await apiClient.post('/users/', { name, email, password, consent_to_data_processing: consent });
            setSuccess(response.data.message);
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            if (err.response && err.response.data && err.response.data.detail) {
                if (Array.isArray(err.response.data.detail)) {
                    const errorMessages = err.response.data.detail.map(e => `${e.loc.join(' -> ')}: ${e.msg}`).join('; ');
                    setError(errorMessages);
                } else {
                    setError(err.response.data.detail);
                }
            } else {
                setError('Произошла ошибка при регистрации.');
            }
        }
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <div className="card shadow-sm">
                    <div className="card-body">
                        <h2 className="card-title text-center mb-4">Регистрация</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Имя</label>
                                <input
                                    type="text"
                                    id="name"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Пароль</label>
                                <input
                                    type="password"
                                    id="password"
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3 form-check">
                                <input
                                    type="checkbox"
                                    id="consent"
                                    className="form-check-input"
                                    checked={consent}
                                    onChange={(e) => setConsent(e.target.checked)}
                                    required
                                />
                                <label htmlFor="consent" className="form-check-label" style={styles.consentText}>
                                    Я ознакомлен(а) с <Link to="/privacy" style={styles.privacyLink}>Политикой обработки персональных данных</Link>. Я согласен(на) на обработку моего адреса электронной почты (обязательно) и имени (указывается по желанию, может быть изменено) для целей регистрации и использования сервиса EventPlan. Согласие может быть отозвано в любое время.
                                </label>
                            </div>
                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary">Зарегистрироваться</button>
                            </div>
                            {error && <div className="alert alert-danger mt-3">{error}</div>}
                            {success && <div className="alert alert-success mt-3">{success}</div>}
                        </form>
                        <div className="text-center mt-3">
                            <small>Уже есть аккаунт? <Link to="/login">Войти</Link></small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    consentText: {
        fontSize: '0.85rem',
        lineHeight: '1.4',
    },
    privacyLink: {
        color: '#007bff',
        textDecoration: 'none',
    }
};

export default RegisterPage;